export default function RemplacementMoteur() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Remplacement du moteur Profalux étape par étape
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Le remplacement d'un moteur Profalux suit une procédure rigoureuse qui prend en compte la spécificité des fils conducteurs intégrés. L'intervention commence par une phase de diagnostic complète : le technicien vérifie la continuité électrique des lames du tablier, teste le moteur tubulaire en direct et analyse la qualité du signal radio. Cette triple vérification permet d'identifier avec certitude si la panne vient du moteur, du tablier ou de la commande, et d'éviter un remplacement inutile.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Une fois le diagnostic confirmé, le technicien dépose le tablier avec précaution pour préserver les lames conductrices. Le moteur tubulaire est extrait de l'axe, et le nouveau moteur Profalux est calibré en fonction du poids et des dimensions du tablier. L'étape cruciale consiste à rétablir la connexion électrique via les fils conducteurs du tablier : chaque lame est testée pour s'assurer qu'elle transmet correctement le courant. Pour les modèles radio, le moteur est appairé avec les télécommandes existantes ou de nouvelles émetteuses sont configurées. Les fins de course sont réglées, le tablier est réinstallé et une série de tests de montée, descente et arrêt d'urgence valide l'installation avant la remise au client.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Déroulement de l'intervention
        </h3>
        <ul className="space-y-3">
          {[
            "Diagnostic complet : test des lames conductrices, moteur et radio",
            "Dépose du tablier en préservant les fils conducteurs intégrés",
            "Retrait du moteur tubulaire défectueux et nettoyage de l'axe",
            "Installation du nouveau moteur Profalux calibré au poids du tablier",
            "Reconnexion électrique via les lames conductrices et test de continuité",
            "Programmation radio et réglage des fins de course avec tests complets",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}